import React from 'react';
import BackButton from '../../components/buttons/back';
import LanguageDropDown from '../../components/buttons/language';

const TopBar = ({ title, onBack }) => {
  return (
    <div className="flex flex-row justify-between items-center pt-3 pb-3 -mx-5 px-5 bg-white">
      <div className="w-16">
        <BackButton onClick={onBack} />
      </div>
      <h2 className="font-primaryMedium text-primary text-base">{title}</h2>
      <div className="w-16">
        <LanguageDropDown />
      </div>
    </div>
  );
};

export default TopBar;
